import { render, staticRenderFns } from "./ElementPresetChooser.vue?vue&type=template&id=962332dc&"
import script from "./ElementPresetChooser.vue?vue&type=script&lang=ts&"
export * from "./ElementPresetChooser.vue?vue&type=script&lang=ts&"
import style0 from "./ElementPresetChooser.vue?vue&type=style&index=0&id=962332dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports